import moment from 'moment';

function DateFormatFilter() {
    return (input) => {
        return input ? moment(input).toDate() : '';
    };
}

export default DateFormatFilter;


// WEBPACK FOOTER //
// ./src/app/filters/dateFormat.js